
import { Vue, Component, Prop } from "vue-property-decorator";
import SectionHeader from "./components/SectionHeader.vue";
import InfoField from "./components/InfoField.vue";
import InfoGrid from "./components/InfoGrid.vue";
import Roles from "@/entities/Roles";
import moment from 'moment';
import { User } from "@/generated/graphql";

@Component({
  components: {
    SectionHeader,
    InfoField,
    InfoGrid,
  },
})
export default class ClientInformation extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: any;
  @Prop({ type: Object, required: true }) readonly proejctData!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  get isAdmin(): boolean {
    return this.currentUser.role === Roles.ADMIN;
  }

  formatDate(dateString: string | null | undefined): string {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);
      
      // Check if the date is valid
      if (isNaN(date.getTime())) {
        return "Invalid date";
      }
     return moment(dateString).format("DD MMM, YYYY");
    } catch (e) {
      return "Invalid date";
    }
  }
}
